module.exports = __webpack_public_path__ + "img/Lego.665443d2.jpg";